<div class="multi-select-container">
  <!-- Label -->
  <label *ngIf="label" class="block text-sm font-medium text-gray-700 mb-2">
    {{ label }}
  </label>

  <!-- Search Input -->
  <div class="relative">
    <input
      [formControl]="searchControl"
      [placeholder]="placeholder"
      [disabled]="disabled || loading"
      class="w-full px-3 py-2 border border-gray-300 rounded-md focus:ring-2 focus:ring-blue-500 focus:border-blue-500 disabled:bg-gray-50 disabled:text-gray-500">
    
    <!-- Loading Spinner -->
    <div *ngIf="loading" class="absolute right-3 top-1/2 transform -translate-y-1/2">
      <div class="animate-spin rounded-full h-4 w-4 border-b-2 border-blue-600"></div>
    </div>
  </div>

  <!-- Selected Items Chips -->
  <div *ngIf="selectedItems.length > 0" class="mt-2 flex flex-wrap gap-2">
    <div *ngFor="let item of selectedItems" 
         class="inline-flex items-center px-2 py-1 bg-blue-100 text-blue-800 text-xs rounded-full">
      <span class="mr-1">{{ item.name }}</span>
      <button 
        (click)="removeItem(item)"
        [disabled]="disabled"
        class="ml-1 text-blue-600 hover:text-blue-800 focus:outline-none">
        <svg class="w-3 h-3" fill="currentColor" viewBox="0 0 20 20">
          <path fill-rule="evenodd" d="M4.293 4.293a1 1 0 011.414 0L10 8.586l4.293-4.293a1 1 0 111.414 1.414L11.414 10l4.293 4.293a1 1 0 01-1.414 1.414L10 11.414l-4.293 4.293a1 1 0 01-1.414-1.414L8.586 10 4.293 5.707a1 1 0 010-1.414z" clip-rule="evenodd"></path>
        </svg>
      </button>
    </div>
    <button 
      *ngIf="selectedItems.length > 0"
      (click)="clearAll()"
      [disabled]="disabled"
      class="text-xs text-gray-500 hover:text-gray-700 underline">
      Alle entfernen
    </button>
  </div>

  <!-- Dropdown Options -->
  <div *ngIf="searchControl.value" 
       class="absolute z-10 w-full mt-1 bg-white border border-gray-300 rounded-md shadow-lg max-h-60 overflow-y-auto">
    <div *ngFor="let item of filteredItems | async" 
         (click)="toggleSelection(item)"
         class="px-3 py-2 hover:bg-gray-100 cursor-pointer flex items-center justify-between"
         [class.bg-blue-50]="isSelected(item)">
      <div class="flex-1">
        <div class="text-sm font-medium text-gray-900">{{ item.name }}</div>
        <div *ngIf="item.description" class="text-xs text-gray-500">{{ item.description }}</div>
      </div>
      <div *ngIf="isSelected(item)" class="text-blue-600">
        <svg class="w-4 h-4" fill="currentColor" viewBox="0 0 20 20">
          <path fill-rule="evenodd" d="M16.707 5.293a1 1 0 010 1.414l-8 8a1 1 0 01-1.414 0l-4-4a1 1 0 011.414-1.414L8 12.586l7.293-7.293a1 1 0 011.414 0z" clip-rule="evenodd"></path>
        </svg>
      </div>
    </div>
    <div *ngIf="(filteredItems | async)?.length === 0" class="px-3 py-2 text-sm text-gray-500">
      Keine Ergebnisse gefunden
    </div>
  </div>
</div>


